const boundKey = '__pbServiceModalBound__';

if (!window[boundKey]) {
  window[boundKey] = true;
  let locked = false;
  let previousOverflow = '';
  let previousPaddingRight = '';
  let activeOpener = null;

  const lockScroll = () => {
    if (locked) return;
    const root = document.documentElement;
    previousOverflow = root.style.overflow;
    previousPaddingRight = root.style.paddingRight;
    const scrollbar = window.innerWidth - root.clientWidth;
    root.style.overflow = 'hidden';
    if (scrollbar > 0) root.style.paddingRight = `${scrollbar}px`;
    locked = true;
  };

  const unlockScroll = () => {
    if (!locked || document.querySelector('dialog[data-pb-service-modal][open]')) return;
    const root = document.documentElement;
    root.style.overflow = previousOverflow;
    root.style.paddingRight = previousPaddingRight;
    locked = false;
  };

  const restoreRemovedDialog = () => {
    if (!locked || document.querySelector('dialog[data-pb-service-modal][open]')) return;
    unlockScroll();
    if (activeOpener?.isConnected) activeOpener.focus?.();
    activeOpener = null;
  };

  const close = (dialog) => {
    if (!dialog?.open) return;
    dialog.close();
    // Chromium dispatches `close` on the next animation frame; release the lock now.
    unlockScroll();
  };

  const focusableControls = (dialog) => Array.from(dialog.querySelectorAll('a[href], button, [tabindex]')).filter((control) =>
    !control.hasAttribute('disabled') && control.getAttribute('tabindex') !== '-1' && !control.closest('[hidden]')
  );

  document.addEventListener('click', (event) => {
    const opener = event.target.closest?.('[data-pb-service-modal-open]');
    if (opener) {
      const panel = opener.closest?.('.pb-service-panel');
      const dialog = Array.from(panel?.querySelectorAll?.('dialog[data-pb-service-modal]') || []).find((candidate) =>
        candidate.id === opener.dataset.pbServiceModalOpen && candidate instanceof HTMLDialogElement
      );
      if (!dialog) return;
      event.preventDefault();
      if (!dialog.open) {
        lockScroll();
        activeOpener = opener;
        try {
          dialog.showModal();
        } catch (error) {
          activeOpener = null;
          unlockScroll();
          console.warn('Purchase clarity service dialog could not open', error);
        }
      }
      return;
    }

    const closeButton = event.target.closest?.('[data-pb-service-modal-close]');
    if (closeButton) {
      close(closeButton.closest('dialog[data-pb-service-modal]'));
      return;
    }

    const dialog = event.target.closest?.('dialog[data-pb-service-modal]');
    if (dialog && event.target === dialog) close(dialog);
  });

  document.addEventListener('cancel', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.matches('[data-pb-service-modal]')) {
      event.preventDefault();
      close(event.target);
    }
  }, true);

  document.addEventListener('close', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target.matches('[data-pb-service-modal]')) {
      unlockScroll();
      if (!document.querySelector('dialog[data-pb-service-modal][open]')) activeOpener = null;
    }
  }, true);

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
    const dialog = event.target.closest?.('dialog[data-pb-service-modal][open]');
    if (!(dialog instanceof HTMLDialogElement)) return;
    const controls = focusableControls(dialog);
    if (!controls.length) return;
    const first = controls[0];
    const last = controls[controls.length - 1];
    const current = document.activeElement;
    if (event.shiftKey ? current === first || !dialog.contains(current) : current === last || !dialog.contains(current)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    }
  }, true);

  const observer = new MutationObserver(restoreRemovedDialog);
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
